import NavBar from '@/components/Nav.vue';

import regex from '@/configs/regex.js'

export default {
    name: 'WelfareDetailPage',
    components: {
        NavBar,
    },
    data() {
        return {
            welfare: {
                receiver_name: '',
                receiver_mobile: '',
                receiver_address: '',
                receiver_name_need: true,
                receiver_address_need: true
            },
            timer: null,
            loading: false,
            isFill: false,
            confirm: false,
            needConfirm: false
        }
    },
    created() {
        this.$http.get('welfare/' + this.$route.params.id).then(result => {
            this.welfare = result.data.welfare;
            this.isFill = result.data.welfare.receiver_mobile ? true : false;
            this.needConfirm = result.data.welfare.confirm;
        });
    },
    unmounted() {
        clearTimeout(this.timer);
    },
    methods: {
        check() {
            if ((this.welfare.receiver_name_need && ! this.welfare.receiver_name.length) || (this.welfare.receiver_address_need && ! this.welfare.receiver_address.length) || ! this.welfare.receiver_mobile.length) {
                this.$toast('请输入完整信息');
            } else if (! regex.mobile.test(this.welfare.receiver_mobile)) {
                this.$toast('请输入正确的手机号');
            } else if (this.needConfirm) {
                this.confirm = true;
            } else {
                this.submit();
            }
        },
        submit() {
            if (! this.loading) {
                this.loading = true;
                this.$http.put('welfare/' + this.$route.params.id, this.welfare).then((res) => {
                    if (res.code === 1000) {
                        this.timer = setTimeout(() => {
                            this.$router.back();
                        }, 1500);
                    } else {
                        this.$toast(res.message);
                    }
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
}